import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import * as S from "./styles";
import { getBeneficiaryType, getBeneficiaryStatus, scrollToTop } from "utils";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";


const TablePayrollBenefits = ({
  beneficiaryList,
  page = 1,
  totalPages,
  setPage,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
    scrollToTop();
  };


  return (
    <S.TableContainer>
      <S.StyledTable>
        <S.StyledTableHead>
          <tr>
            <S.StyledTableHeaderCell>Nome</S.StyledTableHeaderCell>
            <S.StyledTableHeaderCell>NIS</S.StyledTableHeaderCell>
            <S.StyledTableHeaderCell>Status do beneficiário</S.StyledTableHeaderCell>
            <S.StyledTableHeaderCell>Tipo de beneficiário</S.StyledTableHeaderCell>
          </tr>
        </S.StyledTableHead>
        <S.StyledTableBody>
          {beneficiaryList?.map((benefit) => {
            const beneficiaryType = getBeneficiaryType(benefit.b_type);
            const beneficiaryStatus = getBeneficiaryStatus(benefit.b_status);
            //const irregularityDate = new Date(irregularity.irregularity_date);

            return (
              <S.StyledTableRow key={benefit.id}>
                <S.StyledTableCell>
                  {benefit?.name || ""}
                </S.StyledTableCell>
                <S.StyledTableCell>
                  {benefit?.nis || ""}
                </S.StyledTableCell>
                <S.StyledTableCell>{beneficiaryStatus}</S.StyledTableCell>
                <S.StyledTableCell>{beneficiaryType}</S.StyledTableCell>

              </S.StyledTableRow>
            );
          })}
        </S.StyledTableBody>
      </S.StyledTable>
      <S.TableFooter>
        <Typography>
          Página {page} de {totalPages}
        </Typography>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handleChange}
          renderItem={(item) => (
            <PaginationItem
              slots={{ previous: WestIcon, next: EastIcon }}
              {...item}
            />
          )}
        />
      </S.TableFooter>
    </S.TableContainer>
  );
};

export default TablePayrollBenefits;
